export enum ClassificationStatusEnum {
  Sent = 'Sent',
  ConvertedLead = 'Converted - Lead',
  Converted = 'Converted',
  ConvertedChannel = 'Converted Channel',
  Converted_Channel = 'Converted - Channel',
  Register = 'Register',
  Replied = 'Replied',
  Forwarded = 'Forwarded',
  Other = 'Other',
  PostConversionComplaint = 'PostConversion Complaint',
  BadFitCompany = 'Bad Fit Company',
  UnsubscribeCompany = 'Unsubscribe Company',
  Competitor = 'Competitor',
  Client = 'Client',
  DeleteFrom = 'Delete From',
  Inbox = 'Inbox',
  ClosedCompany = 'Closed CO.',
  AbuseReportCompany = 'Abuse Report CO.',
  ToContact = 'To Contact',
  OutOfOffice = 'Out Of Office',
  ConnectionRequestAccepted = 'Connection Request Accepted',
  Trash = 'Trash',
  OutOfCompany = 'Out Of Company',
  INBOX = 'INBOX',
  BadFitNoReference = 'Bad Fit - No Reference',
  BadFitReference = 'Bad Fit - Reference',
}
